/* eslint-disable no-useless-escape */

const docLang = document.documentElement.lang;
export const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
export const labels = {
  close: {
    de: 'Popup schließen',
    en: 'Cose Popup',
  },
  prev: {
    de: 'Vorheriger Stop',
    en: 'Previous Stop',
  },
  next: {
    de: 'Nächster Stop',
    en: 'Next Stop',
  },
  play: {
    de: 'Audio abspielen',
    en: 'Play audio',
  },
  rewind: {
    de: 'Zurückspulen 15 Sekunden',
    en: 'Rewind 15 seconds',
  },
  forward: {
    de: 'Vorspulen 15 Sekunden',
    en: 'Forward 15 seconds',
  },
};

export const overlayHtml = /* html */ `<section class="audiotour-overlay" role="dialog"
aria-modal="true" aria-labelledby="dialog-label" aria-describedby="dialog-description">
<div class="audiotour-overlay__inner">
    <button class="audiotour-overlay__close" type="button">
        <i class="icon-plus" aria-hidden="true"></i>
        <span class="sr-only">${labels.close[lang]}</span>
    </button>
    <div class="audiotour-overlay__content">
        <header>
            <h4 class="audiotour-overlay__headline" id="dialog-label"></h4>
            <p class="audiotour-overlay__copy" id="dialog-description"></p>
            <h4 class="audiotour-overlay__station"></h4>
        </header>
        <ul class="audiotour-overlay__image-wrapper"></ul>
        <nav class="audiotour-overlay__image-nav" aria-label="Bildnavigation">
            <ul class="audiotour-overlay__image-nav-wrapper"></ul>
        </nav>
        <div class="audiotour-overlay__audio plyr-wrapper">
            <audio class="plyr-player plyr-player--audio" controls crossorigin>
                <source src>
            </audio>
        </div>

        <div class="audiotour-overlay__audio-progress">
          <span data-current-time></span>
          <span data-duration></span>
        </div>

        <div class="audiotour-overlay__audio-control">
          <div class="audiotour-overlay__audio-control__middle">
            <button class="audio-control__button-rewind" type="button">
              <i class="audio-control__icon-rewind icon-rewind" aria-hidden="true"></i>
              <span class="sr-only">${labels.rewind[lang]}</span>
            </button>

            <button class="audio-control__button-play" type="button">
              <i class="audio-control__icon-play icon-play" data-state="play" aria-hidden="true"></i>
              <i class="audio-control__icon-pause icon-pause" data-state="pause" aria-hidden="true"></i>
              <span class="sr-only">${labels.play[lang]}</span>
            </button>

            <button class="audio-control__button-forward" type="button">
              <i class="audio-control__icon-forward icon-forward" aria-hidden="true"></i>
              <span class="sr-only">${labels.forward[lang]}</span>
            </button>
          </div>

          <div class="audiotour-overlay__audio-control__right">
            <button class="audio-control__button-sound" type="button">
              <i class="audio-control__icon-sound-off icon-sound-off" data-state="unmuted" aria-hidden="true"></i>
              <i class="audio-control__icon-sound-on icon-sound-on" data-state="muted" aria-hidden="true"></i>
              <span class="sr-only">Audio Stummschalten</span>
            </button>
          </div>
        </div>

        <nav class="audioguide-overlay__audio-nav" aria-label="Audionavigation">
            <button class="audioguide-overlay__prev-next is-prev" type="button">
                <i class="icon-chevron-left" aria-hidden="true"></i>
                <span>${labels.prev[lang]}</span>
            </button>
            <button class="audioguide-overlay__prev-next is-next" type="button">
                <span>${labels.next[lang]}</span>
                <i class="icon-chevron-right" aria-hidden="true"></i>
            </button>
        </nav>
    </div>
</div>
</section>
`;
